"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetServiceFeesResponseAllOfToJSON = exports.GetServiceFeesResponseAllOfFromJSONTyped = exports.GetServiceFeesResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetServiceFeesResponseAllOfFromJSON(json) {
    return GetServiceFeesResponseAllOfFromJSONTyped(json, false);
}
exports.GetServiceFeesResponseAllOfFromJSON = GetServiceFeesResponseAllOfFromJSON;
function GetServiceFeesResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'serviceFees': (json['serviceFees'].map(_1.ServiceFeeFromJSON)),
    };
}
exports.GetServiceFeesResponseAllOfFromJSONTyped = GetServiceFeesResponseAllOfFromJSONTyped;
function GetServiceFeesResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'serviceFees': (value.serviceFees.map(_1.ServiceFeeToJSON)),
    };
}
exports.GetServiceFeesResponseAllOfToJSON = GetServiceFeesResponseAllOfToJSON;
